const GOOGLE_CLOUD_CLIENT_ID =
  // "185453445787-qmotum8m0l7l9628ibshrd5q2fnp156v.apps.googleusercontent.com"; //Yitzchak
  "326709672169-8qtijhb990hc4c5f03m6tl6583fvi9a2.apps.googleusercontent.com"; //Alex

const USER_LOCAL_STORAGE_NAME = "userToken";

export { GOOGLE_CLOUD_CLIENT_ID, USER_LOCAL_STORAGE_NAME };
